import { hotjar } from 'react-hotjar'

import { env } from '@/config/env'

export function initHotjar() {
  if (env.isProd) hotjar.initialize(env.hotjarId!, env.hotjarSV!)
}
